export default "__VITE_ASSET__DRuiRdGr__"